import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EditorProvider, useEditor } from '../contexts/EditorContext';
import KonvaEditor from '../components/editor/KonvaEditor';

const EditorPageContent = () => {
  const { carouselId } = useParams();
  const { setCarouselId, loadFromBackend, loading } = useEditor();
  
  useEffect(() => {
    if (carouselId) {
      console.log('🎨 Editor mounted with carousel ID:', carouselId);
      setCarouselId(carouselId);
      loadFromBackend(carouselId);
    } else {
      console.log('🎨 Editor mounted without carousel ID (new carousel)');
    }
  }, [carouselId, setCarouselId, loadFromBackend]);
  
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading carousel...</p>
        </div>
      </div>
    );
  }
  
  return <KonvaEditor />;
};

const EditorPage = () => {
  return (
    <EditorProvider>
      <EditorPageContent />
    </EditorProvider>
  );
};

export default EditorPage;
